import { IApiSuccessWrapper, IExportStatus } from '$/types'
import { apiSlice } from 'app/services/api'

interface IRecentImports {
  columnDefinitions: IColumnDefinition[]
  dataset1Rows: IRows
}

interface IColumnDefinition {
  field: string
  pinned: boolean
  sortable: boolean
  headerName: string
}

interface IRows {
  rows: IRowEntryWrapper[]
}

interface IRowEntry {
  Id: number
  ImportedBy: string
  EventTables: string
  ImportDate: string
  ImportStatus: string
  ValidationStatus: string
  CommittedBy: string
  CommitDate: string
}

interface IRowEntryWrapper {
  rowEntry: IRowEntry
}

interface IImportDetail {
  id: string
  importedBy: string
  importDate: string
  validationStatus: string
  importStatus: string
  fileDetails: IFileDetails[]
}

interface IFileDetails {
  fileName: string
  eventTable: string
  fileErrors: IErrorDetail[]
}

interface IErrorDetail {
  recordNumber: string
  errorDescription: string
  columnName: string
}

export interface ICommitImport {
  csvFileGroupId: number
  commitAction: string
}

export const getRecentImports = apiSlice
  .enhanceEndpoints({
    addTagTypes: ['DataManagementRecentImport']
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getRecentImports: build.query<IRecentImports, void>({
        query: () => ({
          method: 'GET',
          url: '/datamanagement/imports'
        }),
        transformResponse: (res: IApiSuccessWrapper) => {
          return res.result as IRecentImports
        },
        providesTags: () => {
          const tags = [
            { type: 'DataManagementRecentImport' as const, id: 'LIST' }
          ]

          return tags
        }
      }),
      getRecentImport: build.query<IImportDetail, number>({
        query: (id) => ({
          method: 'GET',
          url: `/datamanagement/importdetails/${id}`
        }),
        transformResponse: (res: IApiSuccessWrapper) => {
          return res.result as IImportDetail
        },
        providesTags: (_res, _err, id) => [
          { type: 'DataManagementRecentImport', id }
        ]
      }),
      addImportDataFiles: build.mutation<IExportStatus, FormData>({
        query: (importContent) => ({
          method: 'POST',
          url: '/datamanagement/ImportFiles',
          body: importContent
        }),
        transformResponse: (res: IApiSuccessWrapper) => {
          return res.result as IExportStatus
        },
        invalidatesTags: () => [
          { type: 'DataManagementRecentImport', id: 'LIST' }
        ]
      }),
      updateImportCommitState: build.mutation<IExportStatus, ICommitImport>({
        query: ({ csvFileGroupId, commitAction }) => ({
          method: 'POST',
          url: '/datamanagement/import/commit',
          body: {
            csvFileGroupId,
            commitAction
          }
        }),
        transformResponse: (res: IApiSuccessWrapper) => {
          return res.result as IExportStatus
        },
        invalidatesTags: (_res, _err, importContent) => [
          { type: 'DataManagementRecentImport', id: 'LIST' },
          {
            type: 'DataManagementRecentImport',
            id: importContent.csvFileGroupId
          }
        ]
      })
    })
  })

export const {
  useGetRecentImportsQuery,
  useGetRecentImportQuery,
  useAddImportDataFilesMutation,
  useUpdateImportCommitStateMutation
} = getRecentImports
